const fullWidth = {
  width: '100%',
};

const section = {
  marginTop: '0.4em',
};

const distributeContents = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const primaryActionButton = {
  position: 'fixed',
  bottom: 0,
  right: 0,
  margin: '0 1em 1em 0',
};

const bareList = {
  margin: 0,
  padding: 0,
  listStyle: 'none',
};

export { bareList, distributeContents, fullWidth, primaryActionButton, section };



// WEBPACK FOOTER //
// ./src/styles/generic.js